// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"16":"error-component","40":"search-component","120":"product-component","590":"artist-component","695":"lang-en","786":"privacy-component","923":"imprint-component"}[chunkId] + "." + {"16":"b4eb6690","40":"fa9eb54b","120":"247534f6","590":"f67dd48c","695":"d60b649b","786":"4ededc93","923":"81afd9d2"}[chunkId] + ".js";
};